import { addYears } from "../../../../../../react-core/utils/date";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { TransferType } from "../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { InvestmentAllocation } from "../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { InstrumentSelection } from "../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";
import { PensionTransfer } from "../../../../../../Wrap/Models/Models/Processes/Quote/Pension/PensionTransfer";
import { PensionBase } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { MoneyHelper } from "../../../../../Shared/Common/MoneyHelper";
import { TransferHelper } from "./TransferHelper";

export class PensionHelper {
    static clientSinglePayment(model: PensionBase): Money {
        let taxReliefValue: number =
            model && model?.TaxReliefPercentage && model?.TaxReliefPercentage?.Value
                ? 1 + model?.TaxReliefPercentage?.Value
                : 1.25;
        if (!model?.ClientSinglePayment?.TaxRelief) {
            taxReliefValue = 1;
        }
        let result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.ClientSinglePayment != null && model?.ClientSinglePayment.Money != null) {
            result = {
                Amount: model.ClientSinglePayment.Money.Amount * taxReliefValue,
                Currency: model.ClientSinglePayment.Money.Currency,
            };
        }

        return result;
    }

    static employerSinglePayment(model: PensionBase): Money {
        let result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.EmployerSinglePayment != null && model?.EmployerSinglePayment?.Money != null)
            {result = model.EmployerSinglePayment.Money;}
        return result;
    }

    static thirdPartySinglePayment(model: PensionBase): Money {
        const taxReliefValue: number =
            model && model.TaxReliefPercentage && model.TaxReliefPercentage.Value
                ? 1 + model.TaxReliefPercentage.Value
                : 1.25;
        const result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.ThirdPartySinglePayment != null && model?.ThirdPartySinglePayment?.Money != null) {
            const isTaxReliefApplicable = model.ThirdPartySinglePayment.TaxRelief;
            result.Amount = isTaxReliefApplicable
                ? MoneyHelper.roundNumberToDecimalPlaces(model.ThirdPartySinglePayment.Money.Amount * taxReliefValue, 2)
                : model.ThirdPartySinglePayment.Money.Amount;
        }

        return result;
    }

    static employerSalaryDeductionSinglePayment(model: PensionBase): Money {
        const taxReliefValue: number =
            model && model.TaxReliefPercentage && model.TaxReliefPercentage.Value
                ? 1 + model.TaxReliefPercentage.Value
                : 1.25;
        const result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.EmployerSalaryDeductionSinglePayment != null && model?.EmployerSalaryDeductionSinglePayment?.Money != null) {
            const isTaxReliefApplicable = model.EmployerSalaryDeductionSinglePayment.TaxRelief;
            result.Amount = isTaxReliefApplicable
                ? MoneyHelper.roundNumberToDecimalPlaces(model.EmployerSalaryDeductionSinglePayment.Money.Amount * taxReliefValue, 2)
                : model.EmployerSalaryDeductionSinglePayment.Money.Amount;
        }

        return result;
    }

    static clientRegularPayment(model: PensionBase): Money {
        const taxReliefValue: number =
            model && model.ClientRegularPayment && model.ClientRegularPayment.TaxRelief
                ? 1.25 
                : 1;
        let result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.ClientRegularPayment != null && model?.ClientRegularPayment.Money != null) {
            result = {
                Amount: model.ClientRegularPayment.Money.Amount * taxReliefValue,
                Currency: model.ClientRegularPayment.Money.Currency,
            };
        }

        return result;
    }

    static employerRegularPayment(model: PensionBase): Money {
        let result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.EmployerRegularPayment != null && model?.EmployerRegularPayment?.Money != null)
            {result = model.EmployerRegularPayment.Money;}
        return result;
    }

    static thirdPartyRegulaPayment(model: PensionBase): Money {
        const taxReliefValue: number =
            model && model.TaxReliefPercentage && model.TaxReliefPercentage.Value
                ? 1 + model.TaxReliefPercentage.Value
                : 1.25;
        const result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.ThirdPartyRegularPayment != null && model?.ThirdPartyRegularPayment.Money != null) {
            const isTaxReliefApplicable = model.ThirdPartyRegularPayment.TaxRelief;
            result.Amount = isTaxReliefApplicable
                ? MoneyHelper.roundNumberToDecimalPlaces(
                      model.ThirdPartyRegularPayment.Money.Amount * taxReliefValue,
                      2
                  )
                : model.ThirdPartyRegularPayment.Money.Amount;
        }

        return result;
    }

    static employerSalaryDeductionRegularPayment(model: PensionBase): Money {
        const taxReliefValue: number =
            model && model.TaxReliefPercentage && model.TaxReliefPercentage.Value
                ? 1 + model.TaxReliefPercentage.Value
                : 1.25;
        const result: Money = {
            Amount: 0,
            Currency: MoneyHelper.getDefaultCurrency(),
        };
        if (model?.EmployerSalaryDeductionRegularPayment != null && model?.EmployerSalaryDeductionRegularPayment.Money != null) {
            const isTaxReliefApplicable = model.EmployerSalaryDeductionRegularPayment.TaxRelief;
            result.Amount = isTaxReliefApplicable
                ? MoneyHelper.roundNumberToDecimalPlaces(
                    model.EmployerSalaryDeductionRegularPayment.Money.Amount * taxReliefValue,
                    2
                )
                : model.EmployerSalaryDeductionRegularPayment.Money.Amount;
        }

        return result;
    }

    static singlePaymentsTotal(model: PensionBase): number {
        const client = this.clientSinglePayment(model);
        const employer = this.employerSinglePayment(model);
        const thirdparty = this.thirdPartySinglePayment(model);
        const employerSalaryDeduction = this.employerSalaryDeductionSinglePayment(model);
        return client.Amount + employer.Amount + thirdparty.Amount + employerSalaryDeduction.Amount;
    }

    static regularPaymentsTotalForCharges(model: PensionBase): number {
        const client = this.clientRegularPayment(model);
        const employer = this.employerRegularPayment(model);
        const thirdparty = this.thirdPartyRegulaPayment(model);
        const employerSalaryDeduction = this.employerSalaryDeductionRegularPayment(model);
        return client.Amount + employer.Amount + thirdparty.Amount + employerSalaryDeduction.Amount;
    }

    static getTransfersTotal(transfers: PensionTransfer[]) {
        let result = 0;

        if (!transfers || transfers.length === 0) {return result;}

        transfers.forEach((transfer) => {
            if (
                transfer.TransferType === TransferType.Cash &&
                transfer.CurrentValue &&
                transfer.CurrentValue.Amount > 0
            ) {
                result += transfer.CurrentValue.Amount;
            } else {
                result += TransferHelper.getTransferInvestmentTotal(transfer.Instruments, transfer.ReRegisterValue);
            }
        });

        return result;
    }

    static transfersTotal(model: PensionBase): number {
        const transfers = model?.PensionTransfers;
        return this.getTransfersTotal(transfers);
    }

    static hasRegularPayments(model: PensionBase): boolean {
        if (model == null) {return false;}

        const client = model.ClientRegularPayment != null && model.ClientRegularPayment.Money != null;
        const employer = model.EmployerRegularPayment != null && model.EmployerRegularPayment.Money != null;
        const thirdParty = model.ThirdPartyRegularPayment != null && model.ThirdPartyRegularPayment.Money != null;
        const employerSalaryDeduction = model.EmployerSalaryDeductionRegularPayment != null && model.EmployerSalaryDeductionRegularPayment.Money != null;

        return client || employer || thirdParty || employerSalaryDeduction;
    }

    static hasSinglePayments(model: PensionBase): boolean {
        if (model == null) {return false;}

        const client = model.ClientSinglePayment != null && model.ClientSinglePayment.Money != null;
        const employer = model.EmployerSinglePayment != null && model.EmployerSinglePayment.Money != null;
        const thirdParty = model.ThirdPartySinglePayment != null && model.ThirdPartySinglePayment.Money != null;
        const employerSalaryDeduction = model.EmployerSalaryDeductionSinglePayment != null && model.EmployerSalaryDeductionSinglePayment.Money != null;

        return client || employer || thirdParty || employerSalaryDeduction;
    }

    static hasPensionTransfers(model: PensionBase): boolean {
        return model && model.PensionTransfers && model.PensionTransfers.length > 0;
    }

    static getTransfersPeaTotal(transfers: PensionTransfer[]) {
        let result = 0;

        if (!transfers || transfers.length === 0) { return result; }

        transfers.forEach((transfer) => {
            if (transfer?.Instruments?.length > 0) {
                result += TransferHelper.getTransferPeaInvestmentTotal(transfer.Instruments);
            }
        });

        return result;
    }

    static getPaymentsPeaTotal(instruments: InstrumentSelection[]) {
        let result = 0;

        if (!instruments || instruments.length === 0) { return result; }

        instruments.forEach((instrument) => {
            if (![ProductType.Cash, ProductType.OffPlatform].includes(instrument?.Instrument?.Type)) {
                result +=
                    (instrument?.Single?.Money?.Amount ?? 0) +
                    (instrument?.ClientRegular?.Money?.Amount ?? 0) +
                    (instrument?.EmployerRegular?.Money?.Amount ?? 0) +
                    (instrument?.EmployerSalaryDeductionRegular?.Money?.Amount ?? 0) +
                    (instrument?.ThirdPartyRegular?.Money?.Amount ?? 0) +
                    (instrument?.Transfer?.Money?.Amount ?? 0);
            }
        });

        return result;
    }

    static getDisinvestmentPeaTotal(instruments: InvestmentAllocation[], totalAmount: number) {
        let result = 0;

        if (!instruments || instruments.length === 0) { return result; }

        instruments.forEach((instrument) => {
            if (![ProductType.Cash, ProductType.OffPlatform].includes(instrument?.Type)) {
                result += instrument?.Percentage * totalAmount / 100;
            }
        });

        return result;
    }
}

export const LessThanAge = (age: number, dateOfBirth: Date) => {
    const now = new Date();
    return addYears(dateOfBirth, age) > now;
};
